(ns ductile.ui.labels
  (:require #?@(:clj [[ductile.barcode :as barcode]
                      [ductile.base64 :as base64]]
                :cljs [[ductile.ui.components :as ui]])
            [clojure.string :as str]
            [ductile.time.format :as time-format]
            [ductile.workflow.equipment-utils :as equipment-utils]))

(defn vin-labels-small [fahrzeuge]
  [:<>
   [:style {:type "text/css" :media "print"}
    "@page { size: 90mm 20mm; margin: 2mm 2mm 0 2mm; }"]
   [:div.not-prose.border.border-transparent
    [:div.mx-auto
     [:div.bg-white.max-w-4xl.mx-auto.p-12.shadow-lg.relative.print:max-w-none.print:shadow-none.print:p-0.page-break-avoid
      {:class "screen:min-h-[68rem] print:min-h-auto"}
      (into [:div.flex.flex-col.gap-3.print:gap-0.items-center.page-break-avoid]
            (map (fn [fahrzeug]
                   [:div.border.border-black.flex.flex-col.items-center.page-break-avoid
                    {:class ["w-[300px]" "h-[80px]" "print:border-0" "print:w-[90mm]" "print:h-[17mm]"]}
                    [:div {:class ["print:w-[80mm]" "print:h-[10mm]"]}
                     #?(:cljs [ui/code39 {:class ["print:w-[80mm]" "print:h-[10mm]"]} (:vehicle/vin fahrzeug)]
                        :clj [:img {:class ["print:w-[80mm]" "print:h-[10mm]"]
                                    :src (str "data:image/svg+xml;base64,"
                                              (base64/encode (barcode/generate-barcode-svg "code39" (:vehicle/vin fahrzeug))))}])]
                    [:div {:style {:font-size "10pt"}} (:vehicle/vin fahrzeug)]]))
            fahrzeuge)]]]])

(defn sixt-labels-small [{:keys [transport]}]
  (vin-labels-small (:transport/fahrzeuge transport)))

(defn sixt-labels-big [{:keys [transport]}]
  (let [{:keys [zone row]} (:transport/loading-line transport)]
    [:<>
     [:style {:type "text/css" :media "print"}
      "@page { size: 102mm 76mm; margin: 2mm 2mm 0 2mm; }"]
     [:div.not-prose.border.border-transparent
      [:div.mx-auto
       [:div.bg-white.max-w-4xl.mx-auto.p-12.shadow-lg.relative.print:max-w-none.print:shadow-none.print:p-0.page-break-avoid
        {:class "screen:min-h-[68rem] print:min-h-auto"}
        (into [:div.flex.flex-col.gap-3.print:gap-0.items-center.page-break-avoid]
              (map (fn [fahrzeug]
                     (let [equipment (equipment-utils/equipment-set->map (:vehicle/equipment fahrzeug))
                           loose-parts->count (select-keys equipment ["Werkschlüssel"
                                                                      "Keycard"
                                                                      "Displayschlüssel"
                                                                      "Ersatzschlüssel"
                                                                      "Tablet"
                                                                      "kleines Kabel"
                                                                      "weißes Kabel"
                                                                      "Ambiente Air"
                                                                      "USB Reader"])]
                       [:div.border.border-black.relative.page-break-avoid
                        {:class ["w-[400px]" "h-[280px]" "p-[10px]" "print:border-0" "print:w-[102mm]" "print:h-[74mm]"]}
                        [:div.font-bold.mb-1 {:style {:font-size "12pt"}} "SIXT"]
                        [:div {:class ["print:w-[90mm]" "print:h-[12mm]"]}
                         #?(:cljs [ui/code39 {:class ["print:w-[90mm]" "print:h-[12mm]"]} (:vehicle/vin fahrzeug)]
                            :clj  [:img {:class ["print:w-[90mm]" "print:h-[12mm]"]
                                         :src (str "data:image/svg+xml;base64,"
                                                   (base64/encode (barcode/generate-barcode-svg "code39" (:vehicle/vin fahrzeug))))}])]
                        [:div.font-bold {:style {:font-size "10pt"}} (:vehicle/vin fahrzeug)]
                        [:div.font-bold.mt-1 {:style {:font-size "9pt"}} "Losteile: "]
                        [:div.mt-1 {:style {:font-size "9pt"
                                            :columns 2
                                            :column-gap "20px"}}
                         (into [:<>]
                               (map (fn [part]
                                      [:<> part [:br]]))
                               #_(set ["Werkschlüssel"
                                       "Keycard"
                                       "Displayschlüssel"
                                       "Ersatzschlüssel"
                                       "Tablet"
                                       "kleines Kabel"
                                       "weißes Kabel"
                                       "Ambiente Air"
                                       "USB Reader"])
                               (cond-> loose-parts->count
                                 (contains? loose-parts->count "Ersatzschlüssel") (update "Ersatzschlüssel" dec)
                                 true (equipment-utils/equipment-map->set)))]
                        [:div.absolute.flex.justify-between
                         {:style {:font-size "9pt"}
                          :class ["bottom-[10px]" "left-[10px]" "right-[10px]"
                                  "print:bottom-[2mm]" "print:left-[2mm]" "print:right-[2mm]"]}
                         [:div "Eingangsdatum: " (if-let [entry-datetime (:entry/datetime fahrzeug)]
                                                   (time-format/->str {:format :date :style :short} entry-datetime)
                                                   "–")]
                         [:div.font-bold (str "Zug: " (get-in transport [:transport/transporter :truck/number] "–")
                                              " " zone row)]]])))
              (:transport/fahrzeuge transport))]]]]))
